import * as React from "react";
const IconAdjuntar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#4F4FFF"
      d="M11.768 17.49a5.336 5.336 0 0 1-3.906-1.702l-4.756-5.123a.778.778 0 0 1 .3-1.263.78.78 0 0 1 .845.2l4.756 5.12a3.723 3.723 0 0 0 2.758 1.206h.02a3.73 3.73 0 0 0 2.758-1.233 3.768 3.768 0 0 0-.124-5.203L9.674 4.75a2.364 2.364 0 0 0-3.269 0 2.312 2.312 0 0 0 0 3.27l4.69 4.689a.984.984 0 0 0 1.396 0 .979.979 0 0 0 .276-.698.98.98 0 0 0-.276-.695l-4.295-4.31a.78.78 0 0 1 0-1.103.786.786 0 0 1 1.103 0l4.306 4.304a2.53 2.53 0 0 1 .748 1.801 2.533 2.533 0 0 1-.748 1.805 2.555 2.555 0 0 1-3.605 0l-4.69-4.69a3.884 3.884 0 0 1 0-5.482 3.862 3.862 0 0 1 2.742-1.13 3.862 3.862 0 0 1 2.742 1.133L15.54 8.39a5.33 5.33 0 0 1-3.743 9.1h-.028Z"
    />
  </svg>
);
export default IconAdjuntar;